export const SET_GROUPS_BYID = 'folders/groups/SET_GROUPS_BYID'
export const OPEN_GROUP = 'folders/groups/OPEN_GROUP'
export const CLOSE_GROUP = 'folders/groups/CLOSE_GROUP'
